export default __webpack_public_path__ + "static/media/First View.02b226b6.jpg";